<template>
    <div>
        <v-dialog
                v-model="showScheduledInvoice" @close="close"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline">
                    <span>Factura Programada</span>
                    <v-spacer></v-spacer>
                    <span style="font-size: 14px; margin-bottom: -10px; color: dimgrey">
                        <span style="color: grey; font-weight: bold">Cliente: </span>
                        {{getClientName()}}
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <my-info message="Altere a data da fatura programada ou ative-a agora."></my-info>
                    <v-layout grid-list-md wrap>
                        <v-flex xs12 sm12 md6 px-2>
                            <v-menu
                                    ref="dialog"
                                    v-model="showEmittedDate"
                                    :disabled="formData.checkToEmmitNow"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="computedEmissionDate"
                                            :disabled="formData.checkToEmmitNow"
                                            label="Data Emissão"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="formData.emittedDate" no-title @input="onEmissionDateChange"></v-date-picker>
                            </v-menu>

                        </v-flex>

                        <v-flex xs3 sm4 md3 >
                            <v-text-field
                                    v-model="formData.days"
                                    :disabled="formData.checkToEmmitNow"
                                    ref="daysTillDue"
                                    label="dias até vencimento"
                                    type="number"
                                    min="0"
                                    @input="updateDueDate">
                            </v-text-field>
                        </v-flex>

                        <v-flex xs9 sm8 md3 px-2>
                            <v-text-field
                                    disabled
                                    :value="computedDueDate"
                                    label="Data Vencimento"
                            ></v-text-field>
                        </v-flex>

                        <v-flex sx12>
                            <v-checkbox
                                    v-model="formData.checkToEmmitNow"
                                    label="Marque para ativar a fatura agora"
                                    type="checkbox"
                                    @change="onCheckToEmmit()"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading_modal" :disabled="checkSaveButton()" color="blue" flat="flat" @click="save()" >Guardar</v-btn>
                    <v-btn v-if="!loading_modal" depressed flat="flat" @click="close()" >Cancelar</v-btn>
                    <v-progress-circular indeterminate color="blue" v-if="loading_modal"></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import moment from 'moment';
    import {eventBus} from "../../main";
    import Vue from 'vue';

    export default {
        name: "ScheduledInvoice",

        mounted(){
            let vm = this;
            this.onScheduledInvoiceOpened(vm);
        },
        beforeDestroy(){
            eventBus.$off('onScheculedInvoiceOpened');
        },

        data(){
            return {
                showEmittedDate: false,
                showDueDate: false,
                loading_modal: false,
                lastChosenEmissionDate: '',
                formData: {
                    emittedDate: '',
                    dueDate: '',
                    days: 15,
                    checkToEmmitNow: false,
                }
            }
        },

        props: ['selectedInvoiceIndex'],

        methods: {
            close(){
                this.showScheduledInvoice = false;
                this.showDueDate = false;
                this.showEmittedDate = false;
                this.formData = {
                    emittedDate: '',
                    dueDate: '',
                    days: 15,
                    checkToEmmitNow: false,
                }
            },

            checkSaveButton(){
                return this.getDiffInDays() < 0
                    || this.formData.days < 0;
            },

            onEmissionDateChange(){
                this.showEmittedDate = false;
                this.updateDueDate();
            },

            getDiffInDays(){
                var m1 = moment().utcOffset(0);
                m1.set({hour:0,minute:0,second:0,millisecond:0});
                m1.toISOString();
                m1.format();

                var m2 = moment(this.formData.emittedDate).utcOffset(0);
                m2.set({hour:0,minute:0,second:0,millisecond:0});
                m2.toISOString();
                m2.format();

                return m2.diff(m1, 'days');
            },

            onCheckToEmmit(){
                if(this.formData.checkToEmmitNow){
                    this.lastChosenEmissionDate = this.formData.emittedDate;
                    this.formData.emittedDate = new Date().toISOString().substr(0, 10);
                }else if(this.lastChosenEmissionDate){
                    this.formData.emittedDate = this.lastChosenEmissionDate;
                }
                this.updateDueDate();
            },

            updateDueDate(){
                this.consoleLog('emittedDate: '+this.formData.emittedDate);
                this.consoleLog('days: '+this.formData.days);

                this.formData.dueDate = moment(this.formData.emittedDate).add(this.formData.days, 'days')
            },

            save(){
                this.loading_modal = true;
                Vue.axios.post('editScheduledInvoice', {
                    invoice_id: this.selectedInvoice.id,
                    emission_date: moment(this.formData.emittedDate).format('YYYY-MM-DD'),
                    due_date: moment(this.formData.dueDate).format('YYYY-MM-DD'),
                    activate_invoice: this.formData.checkToEmmitNow,
                }).then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.handleErrorCodeMessage(response.data);
                        return
                    }

                    let invoice = response.data.response;
                    this.$emit('onScheduledInvoiceDone', invoice);
                    this.showScheduledInvoice = false;

                }).catch(error => {

                }).finally(()=>{
                    this.loading_modal = false;
                })
            },

            onScheduledInvoiceOpened(vm){
                eventBus.$on('onScheculedInvoiceOpened', function () {
                    vm.consoleLog('ScheculedInvoiceOpened opened');
                    vm.formData.emittedDate = vm.selectedInvoice.emission_date;
                    vm.formData.dueDate = vm.selectedInvoice.due_date;
                })
            },

            getClientName(){
                try{
                    return this.selectedInvoice.sell.client.name;
                }catch (e) {
                    return '';
                }
            }
        },
        
        computed: {

            showScheduledInvoice: {
                get(){
                    return this.$store.getters.getShowScheduledInvoice;
                },
                set(value){
                    this.$store.dispatch('setShowScheduledInvoice', value)
                }
            },
            selectedInvoice: {
                get(){
                    return this.$store.getters.getSelectedInvoice;
                },
                set(value){
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            computedEmissionDate:{
                get(){
                    return this.formData.emittedDate ? moment(this.formData.emittedDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
                },
                set(value){
                    this.formData.emittedDate = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedDueDate:{
                get(){
                    return this.formData.dueDate ? moment(this.formData.dueDate).format('DD-MM-YYYY') : moment(this.formData.emittedDate).add(this.formData.days, 'days').format('DD-MM-YYYY');
                },
                set(value){
                    this.formData.dueDate = new Date(value).toISOString().substr(0, 10)
                }
            },
        },
    }
</script>

<style scoped>

</style>